export default __webpack_public_path__ + "static/media/info.bf15c233.svg";